module.exports = __webpack_public_path__ + "assets/img/txt-professionals-03.d07179f4.svg";